import axios from 'axios';

const TagService = {
    cachedList: { "article": [], "showcase": [], "page": [], "unlisted": [], "template": [], "search": [], "renaissance_showcase": [], "renaissance_events": [], "events": [] },
    cachedTime: { "article": 0, "showcase": 0, "page": 0, "unlisted": 0, "template": 0, "search": 0, "renaissance_showcase": 0, "renaissance_events": 0, "events": 0 },
    getList: function (request, updateTime = null) {
        var self = this;
        //check local storage
        var time = parseInt(localStorage.getItem("lthub_cached_tags_time_" + request.area));
        if (time && time > self.cachedTime[request.area]) {
            self.cachedTime[request.area] = time;
            var tags = localStorage.getItem("lthub_cached_tags_" + request.area);
            if (tags) {
                try {
                    self.cachedList[request.area] = JSON.parse(tags);
                } catch (e) {
                    self.cachedList[request.area] = null;
                }
            }

        }
        if (typeof updateTime == "string")
            updateTime = parseInt(updateTime);

        //if current version is old than timestamp from settings
        if (updateTime === null || updateTime > self.cachedTime[request.area] || !self.cachedList[request.area] || self.cachedList[request.area].length == 0) {
            return axios.get("api/tags/list", { params: request }, { withCredentials: true })
                .then((response) => {
                    self.cachedTime[request.area] = updateTime;
                    self.cachedList[request.area] = response.data.data;
                    localStorage.setItem("lthub_cached_tags_" + request.area, JSON.stringify(self.cachedList[request.area]));
                    localStorage.setItem("lthub_cached_tags_time_" + request.area, self.cachedTime[request.area] + "");
                    return self.cachedList[request.area];
                });
        } else {
            return new Promise((resolve, reject) => {
                resolve(self.cachedList[request.area]);
            });
        }
    },
    getEditList: (request) => {
        return axios.get("api/tags/editlist", { params: request }, { withCredentials: true });
    },
    updateTag: (request) => {
        return axios.put("api/tags", request, { withCredentials: true });
    },
    updateTagOrder: (request) => {
        return axios.put("api/tags/order", request, { withCredentials: true });
    },
    deleteTag: (request) => {
        return axios.delete("api/tags/" + request.id, {}, { withCredentials: true });
    },
    getCategories: (request) => {
        return axios.get("api/tags/picklist", { params: request }, { withCredentials: true });
    },
};

export default TagService;